module.exports = __webpack_public_path__ + "static/media/business-lunch-food-court-2.98f6a9e7.jpg";